const RESOURCE_NAME = '/geozones-groups';
import restApi from "@/api/rest-api-object";

export default axios => (restApi(axios, RESOURCE_NAME));